import React, { useEffect, useRef } from 'react';

const Contact = () => {
    const sectionRef = useRef();

    useEffect(() => {
        const section = sectionRef.current;
        const onScroll = (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    section.classList.add('visible');
                }
            });
        };
        const observer = new window.IntersectionObserver(onScroll, { threshold: 0.2 });
        if (section) observer.observe(section);
        return () => observer.disconnect();
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        document.getElementById('form-message').innerHTML = 'Thank you! We will reach out to you at <a href="mailto:olajideayomide946@gmail.com">olajideayomide946@gmail.com</a>.';
        e.target.reset();
    };

    return (
        <section id="contact" ref={sectionRef} className="contact-animate">
            <h2>CONTACT ME</h2>
            <form className="contact-form" onSubmit={handleSubmit} autoComplete="off">
                <div className="form-group">
                    <input type="text" name="name" placeholder="Your Name" required />
                </div>
                <div className="form-group">
                    <input type="email" name="email" placeholder="Your Email" required />
                </div>
                <div className="form-group">
                    <textarea name="message" placeholder="Your Message" required></textarea>
                </div>
                <button className="contact-btn" type="submit">Contact Me to Work</button>
                <div className="form-message" id="form-message"></div>
                <div className="contact-social">
                    <span>Connect with us:</span>
                    <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" title="Twitter">
                        <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/twitter.svg" alt="Twitter" style={{width: '22px', height: '22px'}} />
                    </a>
                    
                    <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer" title="Facebook">
                        <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/facebook.svg" alt="Facebook" style={{width: '22px', height: '22px'}} />
                    </a>
                    <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer" title="Instagram">
                        <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/instagram.svg" alt="Instagram" style={{width: '22px', height: '22px'}} />
                    </a>
                </div>
            </form>
        </section>
    );
};

export default Contact;